import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PatientsHomeComponent } from './patients-home.component';
import { UiJpatsModule } from '../../shared/ui-jpats/ui-jpats.module';
import { LastIncomingPatientsComponent } from './last-incoming-patients/last-incoming-patients.component';
import { PatientsSearchComponent } from './patients-search/patients-search.component'
import { FormsModule } from '@angular/forms';
import {PatientHomeService} from "./shared/services/patient-home.service";
import { RegisterIncomingComponent } from './last-incoming-patients/register-incoming/register-incoming.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UiJpatsModule,

  ],
  declarations: [PatientsHomeComponent, LastIncomingPatientsComponent, PatientsSearchComponent, RegisterIncomingComponent ],
  providers: [PatientHomeService],
  entryComponents: [
    RegisterIncomingComponent
  ],
})
export class PatientsHomeModule { }
